<template>
  <form @submit.prevent="handleSubmit">
    <div
      class="alert text-left"
      :class="{
        'alert-danger': message.error,
        'alert-success': !message.error,
      }"
      role="alert"
      v-show="message.display"
    >
      {{ this.message.content }}
    </div>
    <div class="row">
      <div class="col-md-6">
        <fieldset>
          <legend class="view-legend">Version française</legend>
          <div class="form-group">
            <label for="title">Titre</label>
            <input
              v-model="article.title"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': submitted && !article.title }"
              id="title"
              placeholder="Titre"
              name="title"
            />
          </div>
          <div class="form-group">
            <label for="extract">Extrait</label>
            <textarea
              v-model="article.extract"
              name="extract"
              class="form-control"
              :class="{ 'is-invalid': submitted && !article.extract }"
              id="extract"
              rows="8"
              placeholder="Extrait"
            ></textarea>
          </div>
          <div class="form-group">
            <label for="content">Contenu</label>
            <wysiwyg v-model="article.content" />
          </div>
        </fieldset>
      </div>
      <div class="col-md-6">
        <fieldset>
          <legend class="view-legend">Version anglaise</legend>
          <div class="form-group">
            <label for="title_en">Titre</label>
            <input
              v-model="article.title_en"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': submitted && !article.title_en }"
              id="title_en"
              placeholder="Title"
              name="title_en"
            />
          </div>
          <div class="form-group">
            <label for="extract_en">Extrait</label>
            <textarea
              v-model="article.extract_en"
              name="extract_en"
              class="form-control"
              :class="{ 'is-invalid': submitted && !article.extract_en }"
              id="extract_en"
              rows="8"
              placeholder="Extract"
            ></textarea>
          </div>
          <div class="form-group">
            <label>Contenu</label>
            <wysiwyg v-model="article.content_en" />
          </div>
        </fieldset>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <div class="form-group row">
          <label for="category" class="col-md-2">Catégorie</label>
          <select
            id="category"
            class="form-control col-md-6"
            :class="{ 'is-invalid': submitted && !article.category }"
            v-model="article.category"
          >
            <option disabled value="">Sélectionner la catégorie...</option>
            <option v-for="v in categories" :value="v.code" :key="v.code">
              {{ v.name }}
            </option>
          </select>
        </div>
        <div class="form-group row">
          <label for="photo" class="col-md-2">Image:</label>
          <input
            @change="onFileChange($event)"
            type="file"
            accept="image/png, image/jpeg, image/jpg"
            class="form-control col-md-6"
            :class="{ 'is-invalid': submitted && !article.photo }"
            id="photo"
            placeholder="Image"
            name="photo"
          />
        </div>
        <div class="form-group row" v-show="article.photo">
          <label class="col-md-2"></label>
          <img id="imageDisplay" class="col-md-6" />
        </div>
        <div class="form-group row">
          <label for="publication_start_date" class="col-md-2"
            >Début publication:</label
          >
          <!-- <input
            v-model="article.publication_start_date"
            type="date"
            class="form-control col-md-6"
            :class="{
              'is-invalid': submitted && !article.publication_start_date,
            }"
            id="publication_start_date"
            placeholder="Date de début de publication"
            name="publication_start_date"
          /> -->

          <VueCtkDateTimePicker
            name="publication_start_date"
            class="col-md-6 ml-0 mr-0 pl-0 pr-0"
            v-model="article.publication_start_date"
            label="début de publication"
            color="#0a3764"
            button-color="#0a3764"
            locale="fr"
            input-size="sm"
            format="YYYY-MM-DD HH:mm:ss"
            button-now-translation="Aujourd'hui"
            :error="submitted && !article.publication_start_date ? true : false"
          />
        </div>

        <div class="form-group row">
          <label for="publication_end_date" class="col-md-2"
            >Fin publication:</label
          >
          <!-- <input
            v-model="article.publication_end_date"
            type="date"
            class="form-control col-md-6"
            :class="{
              'is-invalid': submitted && !article.publication_end_date,
            }"
            id="publication_end_date"
            placeholder="Date de fin de publication"
            name="publication_end_date"
          /> -->
          <VueCtkDateTimePicker
            name="publication_end_date"
            class="col-md-6 ml-0 mr-0 pl-0 pr-0"
            v-model="article.publication_end_date"
            label="fin de publication"
            color="#0a3764"
            button-color="#0a3764"
            locale="fr"
            input-size="sm"
            format="YYYY-MM-DD HH:mm:ss"
            button-now-translation="Aujourd'hui"
            :error="submitted && !article.publication_end_date ? true : false"
          />
        </div>

        <div class="form-group row">
          <label class="col-md-2"></label>
          <div class="form-check col-md-8">
            <input
              v-model="article.state"
              class="form-check-input"
              type="checkbox"
              id="gridCheck"
              name="gridCheck"
            />
            <label class="form-check-label" for="gridCheck"> Activé ? </label>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-2"></label>
          <div class="form-check col-md-8">
            <input
              v-model="article.pinned"
              class="form-check-input"
              type="checkbox"
              id="pinned"
              name="pinned"
            />
            <label class="form-check-label" for="pinned"> Epinglé ? </label>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-2"></label>
          <div class="col-md-8">
            <button type="submit" class="btn btn-primary">Enrégister</button>
            <router-link
              class="btn btn-dark action-btn-cancel"
              :to="{ name: 'articles' }"
            >
              Retourner
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import Vue from "vue";

import wysiwyg from "vue-wysiwyg";
Vue.use(wysiwyg, { locale: "fr" }); // config is optional. more below

import { UPDATE_ARTICLE } from "@/store/actions.type";
import { SUCCESS_MESSAGE } from "@/helpers/messages";
import { SET_LOADING } from "@/store/mutations.type";

export default {
  name: "ArticleEditForm",
  data() {
    return {
      article: {
        title: "",
        content: "",
        title_en: "",
        content_en: "",
        publication_start_date: "",
        publication_end_date: "",
        extract: "",
        extract_en: "",
        photo: "",
        category: "",
        state: true,
        pinned: false,
      },
      submitted: false,
      message: {
        error: false,
        display: false,
        content: "",
      },
      categories: [
        {
          code: "discover",
          name: "Découverte",
        },
        {
          code: "actuality",
          name: "Actualité",
        },
      ],
    };
  },
  mounted() {
    this.article = this.$store.state.article.article;
    if (this.article.photo) {
      document.querySelector("#imageDisplay").src = this.article.photo;
    }
  },
  computed: {},
  methods: {
    handleSubmit() {
      // affichage réinitialisé
      this.message.display = false;
      this.message.error = false;

      this.submitted = true;

      const {
        title,
        content,
        publication_start_date,
        publication_end_date,
        extract,
        photo,
        category
      } = this.article;
      if (
        !title ||
        !content ||
        !publication_start_date ||
        !publication_end_date ||
        !extract ||
        !photo ||
        !category
      ) {
        return;
      }

      // console.log(this.article);

      this.$store.commit(SET_LOADING, true);

      this.$store
        .dispatch(UPDATE_ARTICLE, this.article)
        .then(() => {
          this.message.content = SUCCESS_MESSAGE;
          this.message.display = true;

          //On réinitialise l'état
          this.article = {
            title: "",
            content: "",
            title_en: "",
            content_en: "",
            publication_start_date: "",
            publication_end_date: "",
            extract: "",
            extract_en: "",
            photo: "",
            category: "",
            state: true,
          };

          this.submitted = false;
        })
        .catch((error) => {
          this.message.content = `${error} \n ${JSON.stringify(error.errors)}`;
          this.message.display = true;
          this.message.error = true;
          this.submitted = false;
        })
        .finally(() => {
          this.$store.commit(SET_LOADING, false);
        });
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      //console.log(files);
      if (!files.length) return;

      this.getBase64(files[0])
        .then((data) => {
          this.article.photo = String(data);
          document.querySelector("#imageDisplay").src = data;
        })
        .catch(() => (this.article.photo = ""));
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
  },
};
</script>

<style>
@import "~vue-wysiwyg/dist/vueWysiwyg.css";
</style>